import { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import ComponenteError from '../publicaciones/ComponenteError'
import * as registroService from '../servicios/registroService'
import LinkButton from '../ui/LinkButton'

const ERROR_CUENTA = 13
const OK_CUENTA = 14

const Verificar = () => {
  const params = useParams()
  const [errorCode, setErrorCode] = useState(null)
  const hasVerified = useRef(false)

  const VerificarCuenta = async () => {
    try {
      if (hasVerified.current) {
        return
      }
      hasVerified.current = true

      const idUsuario = params.idUsuario
      const codigoVerif = params.codigoVerif
      const { data } = await registroService.verificar(idUsuario, codigoVerif)
      !data.estado ? setErrorCode(ERROR_CUENTA) : setErrorCode(OK_CUENTA)
    } catch (error) {
      const mensaje = `Ocurrió un error al verificar usuario.`
      toastErrorLog(error, mensaje, 'registro')
    }
  }

  useEffect(() => {
    VerificarCuenta()
  }, [])

  return (
    <>
      <br />
      <br />

      <div className="row">
        <div className="col">
          {errorCode !== null && <ComponenteError tipo="I" idAviso={errorCode} />}
          <br />
          {errorCode === OK_CUENTA && (
            <LinkButton className="btn btn-sign-in" to="/Login/1">
              <i className="fa fa-sign-in" aria-hidden="true" /> Iniciar Sesión
            </LinkButton>
          )}
        </div>
      </div>
    </>
  )
}

export default Verificar
